/* eslint-disable no-unused-vars */
import React from "react";
import { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Carousel from 'react-material-ui-carousel'
import './Works.css';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import review1 from '../../assets/reviews/review1.png';
import review2 from '../../assets/reviews/review2.png';
import review3 from '../../assets/reviews/review3.png';
import review4 from '../../assets/reviews/review4.png';
import review5 from '../../assets/reviews/review5.png';
import review6 from '../../assets/reviews/review6.png';
import review7 from '../../assets/reviews/review7.png';
import review8 from '../../assets/reviews/review8.png';
import review9 from '../../assets/reviews/review9.png';
import review10 from '../../assets/reviews/review10.png';
import review11 from '../../assets/reviews/review11.png';
import review12 from '../../assets/reviews/review12.png';
import review13 from '../../assets/reviews/review13.png';
import review14 from '../../assets/reviews/review14.png';
import review15 from '../../assets/reviews/review15.png';
import review16 from '../../assets/reviews/review16.png';

const useStyles = makeStyles((theme) => ({
    main: {
        maxWidth: '100vw',
        marginTop: '3em',
        marginBottom: "auto",
    },
}));

export const Reviews = () => {
    const [projects, setProjects] = useState([
        {
            id: 1,
            image: `${review1}`,
        },
        {
            id: 2,
            image: `${review2}`,
        },
        {
            id: 3,
            image: `${review3}`,
        },
        {
            id: 4,
            image: `${review4}`,
        },
        // {
        //     id: 5,
        //     image: `${review5}`,
        // },
        {
            id: 6,
            image: `${review6}`,
        },
        {
            id: 7,
            image: `${review7}`,
        },
        {
            id: 8,
            image: `${review8}`,
        },
        {
            id: 9,
            image: `${review9}`,
        },
        {
            id: 10,
            image: `${review10}`,
        },
        {
            id: 11,
            image: `${review11}`,
        },
        {
            id: 12,
            image: `${review12}`,
        },
        {
            id: 13,
            image: `${review13}`,
        },
        {
            id: 14,
            image: `${review14}`,
        },
        {
            id: 15,
            image: `${review15}`,
        },
        {
            id: 16,
            image: `${review16}`,
        },
    ]);

    function Project(props) {
        let project = props.item
        return (
            <div className="review" key={project.id}>
                <div className="__img_wrapper_review">
                    <img src={project.image} alt={project.alter} />
                </div>
            </div>
        )
    }

    return (
        <div id="review" className="parent_review">
            <div style={{height: '100%'}}>
                <Carousel
                    // NextIcon={<ArrowForwardIosIcon />}
                    // PrevIcon={<ArrowBackIosNewIcon />}
                    autoPlay
                    interval={4000}
                    animation="slide"
                    duration={1000}
                    navButtonsAlwaysVisible={true}
                >
                    {
                        projects.map((item, i) => <Project key={i} item={item} />)
                    }
                </Carousel>
            </div>
        </div>
    );
};
